var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSpaceInitialized)?_c('root-interface',[(_vm.activePortalInterface)?_c(_vm.activePortalInterface,{tag:"component"}):_vm._e()],1):_c('space-setup-pop-up')],1)}
var staticRenderFns = []

export { render, staticRenderFns }